import { CommonModule, DatePipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { AccountSummaryModule } from '../account-summy/account-summary.module'
import { SiteContextSelectorModule } from '../account-summy/site-context-selector/site-context-selector.module'
import { MaterialModule } from '../shared/material.module'
import { DispenserAgreementModule } from './agreements/dispenser-agreement/dispenser-agreement.module'
import { PriceAgreementModule } from './agreements/price-agreement/price-agreement.module'
import { ShipmentCreditClaimModule } from './agreements/shipment-credit-claim/shipment-credit-claim.module'
import { CreditClaimsModule } from './credit-claims/credit-claims.module'
import { CustomAddressBookModule } from './custom-address-book/custom-address-book.module'
import { ImageLibraryModule } from './image-library/image-library.module'
import { ImportSavedCartModule } from './import-saved-cart/import-saved-cart.module'
import { ProductUpdatesModule } from './product-updates/product-updates.module'
import { RebateClaimsModule } from './rebate-claims/rebate-claims.module'
import { SavedCartsModule } from './saved-carts/saved-carts.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,

    PriceAgreementModule,
    DispenserAgreementModule,
    CreditClaimsModule,
    ImportSavedCartModule,
    SavedCartsModule,
    AccountSummaryModule,
    RebateClaimsModule,
    SiteContextSelectorModule,
    ShipmentCreditClaimModule,
    CustomAddressBookModule,
    ImageLibraryModule,
    ProductUpdatesModule
  ],
  providers: [DatePipe]
})
export class MyAccountModule {}
